export enum AllocationType {
  PORTFOLIO = 'PORTFOLIO',
  ASSET_CLASS = 'ASSET_CLASS',
}



// WEBPACK FOOTER //
// ./src/app/common/enums/AllocationType.ts